import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CauseCodeListLayer from "../components/CauseCodeListLayer";

const CauseCodePage = () => {
  return (
    <>
      <MasterLayout pageTitle="Cause Codes">
        <CauseCodeListLayer />
      </MasterLayout>
    </>
  );
};

export default CauseCodePage;
